module.exports = __webpack_public_path__ + "static/media/red_cross_circle.cc5e6427.svg";